import { push }            from "connected-react-router";
import * as Proptypes      from "prop-types";
import React               from "react";
import { Button }          from "react-bootstrap";
import { connect }         from "react-redux";
import { getAldVitaleUrl } from "../../../dmpconnect/helpers/nav";
import TitleTooltip        from "../../Common/TitleTooltip";

function ALDButton ({
  subSection, className, dispatch
}) {
  return (
    <>
      <TitleTooltip
        id={`ald-button-tooltip-${subSection}`}
        text="Lister les Affections Longue Durée"
      >
        <div className="d-inline-block">
          <Button
            className="btn-icon-only"
            type="button"
            variant="link"
            size="sm"
            onClick={() => dispatch(push(getAldVitaleUrl(subSection)))}
          >
            <img
              src="/images/logo/ald-logo.png"
              alt="ALD"
              style={{ cursor: "pointer", height: "50px" }}
            />
          </Button>
        </div>
      </TitleTooltip>
      {/* {popupOpened && ( */}
      {/*  <ALDPopup */}
      {/*    setPopupOpened={() => setPopupOpened(false)} */}
      {/*    popupTitle="Liste des ALD" */}
      {/*    popupOpened={popupOpened} */}
      {/*    vitaleIndex={vitaleIndex} */}
      {/*    ins={ins} */}
      {/*  /> */}
      {/* )} */}
    </>
  );
}

ALDButton.propTypes    = {
  subSection: Proptypes.string,
  className : Proptypes.string
};
ALDButton.defaultProps = {
  subSection: undefined,
  className : ""
};
export default connect()(ALDButton);
